module.exports = __webpack_public_path__ + "sr.svg?6d79b69b3d34dc97629262e4720439c4";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/sr.svg
// module id = 940
// module chunks = 27